import React from 'react'
import {isNil} from 'lodash'
import iconNames from 'theme/icons'
import theme from 'theme/index'
import {urls} from 'helpers/url'
import {accountHasFeature} from 'helpers/user'
import {features} from 'helpers/constants'

export const AUTO_MINIMISE_SIDEBAR_BELOW = 1280

// Adjust the width of tooltip to show arrows
export const ADJUST_INNER_TOOLTIP_PADDING = 20

const HALF_TOOLTIP_HEIGHT = 90

export const isMyAccount = () => {
  return location && location.pathname && location.pathname.startsWith(urls.myAccount.baseUrl)
}

export const getScrollingElement = () => {
  if (document.documentElement && !isNil(document.documentElement.scrollTop)) return document.documentElement
  return document.body
}

export const getScrollTop = () => {
  return getScrollingElement().scrollTop
}

export const getImageDimensions = (imageSrc, onCallback) => {
  const image = new Image()
  image.src = imageSrc
  image.onload = function () {
    onCallback({
      width: image.naturalWidth,
      height: image.naturalHeight,
    })
  }
}

const MOVE_MS = 25

export const setScrollTop = (scrollTop, duration = 250) => {
  const elm = getScrollingElement()
  if (duration === 0) {
    elm.scrollTop = scrollTop
  } else {
    const diff = scrollTop - elm.scrollTop
    const move = diff * MOVE_MS / duration

    if (move !== 0) {
      let iters = 0
      const numIters = (diff / move)

      const itv = window.setInterval(() => {
        elm.scrollTop += move
        iters++
        if (iters >= numIters) window.clearInterval(itv)
      }, MOVE_MS)
    }
  }
}

export const showSnow = (user) => {
  return accountHasFeature(user, features.SEASONAL_VARIANTS) && new Date().getMonth() === 11
}

// Returns the top position of the module space
// headerHeight = height of the main menu
// 50 = height of the sub-menu
export const getModuleTop = (headerHeight) => headerHeight + 50

export const getTrendIconAndColour = (diff) => {
  if (diff === 0) {
    return {
      icon: iconNames.trendEqual,
      color: theme.palette.primaryIconColor,
    }
  }
  if (diff < 0) {
    return {
      icon: iconNames.trendDown,
      color: theme.palette.warningColor,
    }
  }
  return {
    icon: iconNames.trendUp,
    color: theme.palette.goodColor,
  }
}

export const selectAllText = () => {
  try {
    document.execCommand('selectAll', true)
  } catch {
  }
}

export const isWhite = (color) => {
  return color.toLowerCase() === '#ffffff'
    || color.toLowerCase() === '#fff'
    || color.toLowerCase() === 'white'
}

export const getTooltipArrow = (anchor, visible, tooltip, labelWidth, hasPointer) => {
  const targetOriginDefault = {horizontal: 'left', vertical: 'center'}

  if (!anchor || !visible || (!tooltip && !hasPointer))
    return {
      arrowLeft: null, arrowRight: null,
      targetOrigin: targetOriginDefault,
      placement: 'right',
    }

  const anchorPosition = anchor?.getBoundingClientRect()
  const remainingHeight = window.innerHeight - anchorPosition?.bottom
  const remainingWidth = window.innerWidth - anchorPosition?.right
  const computedPosition = getArrowPosition(remainingHeight, tooltip)

  if (remainingWidth < labelWidth) {
    computedPosition.arrowLeft = null
  } else {
    computedPosition.arrowRight = null
  }

  const {arrowLeft, arrowRight, targetOrigin, placement} = computedPosition
  return {arrowLeft, arrowRight, targetOrigin, placement}
}

export const getArrowPosition = (remainingHeight, tooltip) => {
  let arrowLeft, arrowRight, targetOrigin, placement

  const arrowClassName = tooltip ? 'tooltip-arrow-indicator' : 'arrow-indicator'

  if (remainingHeight < HALF_TOOLTIP_HEIGHT) {
    targetOrigin = {horizontal: 'left', vertical: 'bottom'}
    placement = 'right-end'
    arrowLeft = <div className={`${arrowClassName} left`} style={{marginBottom: '10px'}}/>
    arrowRight = <div className={`${arrowClassName} right`} style={{marginBottom: '10px'}}/>
  } else {
    targetOrigin = {horizontal: 'left', vertical: 'center'}
    placement = 'right'
    arrowLeft = <div className={`${arrowClassName} left`}/>
    arrowRight = <div className={`${arrowClassName} right`}/>
  }

  return {arrowLeft, arrowRight, targetOrigin, placement}
}

export const getContainerClassName = (tooltip, light) => {
  if (tooltip) {
    return 'container-tooltip'
  } else if (light) {
    return 'container-light'
  } else {
    return 'container'
  }
}

export const SUB_MENU_EDGE_MARGIN = 16

export const getSubMenuLeft = (anchorRect, menuWidth) => {
  if (isNil(anchorRect) || !menuWidth) return null

  const fitsRight = anchorRect.right + menuWidth <= window.innerWidth - SUB_MENU_EDGE_MARGIN
  const fitsLeft = anchorRect.left - menuWidth >= SUB_MENU_EDGE_MARGIN

  if (fitsRight || !fitsLeft) return null

  return anchorRect.left - menuWidth
}
